/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_Orders_PaidInputs */

const en_admin_funnel_col_orders_paid = /** @type {(inputs: Admin_Funnel_Col_Orders_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders paid`)
};

/**
* | output |
* | --- |
* | "Orders paid" |
*
* @param {Admin_Funnel_Col_Orders_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_orders_paid = /** @type {((inputs?: Admin_Funnel_Col_Orders_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_Orders_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_orders_paid(inputs)
});
export { admin_funnel_col_orders_paid as "admin.funnel.col.orders_paid" }